// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"CustomerCodeForm_fieldset__3nw1C"};